import { useApi, asArray } from '../../hooks/useApi'

interface ActivityEntry {
  type: string
  globalKeyword: { keyword: string } | null
  details: string | null
  createdAt: string
}

const TYPE_STYLES: Record<string, { bg: string; text: string; label: string }> = {
  cache_hit: { bg: 'bg-emerald-100', text: 'text-emerald-700', label: 'cache hit' },
  cache_miss: { bg: 'bg-orange-100', text: 'text-orange-700', label: 'cache miss' },
  cron: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'cron' },
  seed: { bg: 'bg-purple-100', text: 'text-purple-700', label: 'seed' },
}

function timeAgo(dateStr: string): string {
  const diff = Date.now() - new Date(dateStr).getTime()
  const mins = Math.floor(diff / 60000)
  if (mins < 1) return 'a l\'instant'
  if (mins < 60) return `il y a ${mins}min`
  const hours = Math.floor(mins / 60)
  if (hours < 24) return `il y a ${hours}h`
  const days = Math.floor(hours / 24)
  return `il y a ${days}j`
}

export default function GlobalDbActivity() {
  const { data, loading } = useApi<ActivityEntry[]>('/api/admin/global-db/activity?limit=30')
  const entries = asArray(data)

  return (
    <div className="bg-white rounded-xl border border-[#E2E4ED] p-5">
      <h2 className="text-lg font-semibold text-[#1B2559] mb-4">Activite recente</h2>

      {loading ? (
        <div className="space-y-3">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="animate-pulse bg-[#E2E4ED] rounded h-6 w-full" />
          ))}
        </div>
      ) : entries.length === 0 ? (
        <p className="text-sm text-[#8B8FA7]">Aucune activite recente</p>
      ) : (
        <div className="max-h-96 overflow-y-auto space-y-2 pr-1">
          {entries.map((entry, i) => {
            const style = TYPE_STYLES[entry.type] ?? { bg: 'bg-gray-100', text: 'text-gray-700', label: entry.type }
            return (
              <div key={i} className="flex items-center gap-2 text-sm">
                <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${style.bg} ${style.text} shrink-0`}>
                  {style.label}
                </span>
                <span className="text-[#1B2559] truncate font-medium">
                  {entry.globalKeyword?.keyword ?? '-'}
                </span>
                <span className="text-[#8B8FA7] ml-auto shrink-0 text-xs">
                  {timeAgo(entry.createdAt)}
                </span>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
